import { Genre } from './cms-vod-core/content-controller/genre-model';
import { ContentLanguage } from './cms-vod-core/content-language.model';
import { Content } from './content.model';
import { Metadata } from './metadata.model';

export class ContentLanguageMetadata {
  constructor(
    public id?: number,
    public language?: ContentLanguage,
    public summaryLong?: string,
    public summaryShort?: string,
    public title?: string,
    public titleBrief?: string,
    public genres?: Genre[],
    public metadata?: any,
  ) { }
}

// ContentLanguageMetadata {
// content (Content, optional),
// id (integer, optional),
// language (LanguageEn, optional),
// summaryLong (string, optional),
// summaryShort (string, optional),
// title (string, optional),
// titleBrief (string, optional)
// }
